import { axios, Response } from '../index'

export interface UpdateClinicTaskRequest {
  title: string
}

const updateClinicTask = (
  clinicTaskId: string,
  request: UpdateClinicTaskRequest
): Response<void> => {
  return axios.put(`/v1/favorites/favorites-tasks/${clinicTaskId}`, request)
}

export default updateClinicTask
